import * as angular from 'angular';

/*

How to use:

        vm.showDeletePopup = function (itemId) {
            ngDialog.open({
                template: 'app/components/delete_dialog/delete.dialog.html',
                className: 'dialog-theme',
                data: {
                    item_id: itemId,
                    delete_function: LocationsBuildingsFactory.delete
                }
            });
        }

item_id - the id of item which u want to delete,
delete_function - function (factory item) which is used to deleting this item

*/

(function () {
    'use strict';

    angular
        .module('app')
        .controller('DeleteDialogController', DeleteDialogController);

    function DeleteDialogController($scope, $state, ngDialog, toastr) {
        var vm = this,
            deleteFunction = $scope.ngDialogData.delete_function,
            itemId = $scope.ngDialogData.item_id,
            additionalId = $scope.ngDialogData.additional_id;

        vm.sendDataToBackend = function () {
            deleteFunction(itemId, additionalId).then(function () {
                toastr.success('Pomyślnie usunięto.');
                ngDialog.close();
                $state.reload();
            });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/delete_dialog/delete.controller.ts